import React from 'react';
import styles from './style.module.scss';

interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  label: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label }) => {

  return (
    <label className={styles['checkbox-container']}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className={styles.checkmark}></span>
      {label}
    </label>
  );

};

export default Checkbox;
